import type { Marinade } from "@marinade.finance/marinade-ts-sdk";
import { BN } from "@marinade.finance/marinade-ts-sdk";
import type { Transaction } from "@solana/web3.js";
import { LAMPORTS_PER_SOL } from "@solana/web3.js";
import i18n from "i18next";

export const INVALID_AMOUNT = 0;

const INSUFFICIENT_AMOUNT_ERROR = i18n
  .t("appPage.errors.insufficientAmount")
  ?.replace("{{amount}}", INVALID_AMOUNT.toString());

export const constructLiquidityActionsTx = async (
  marinade: Marinade,
  amount: number,
  action: "deposit" | "withdraw"
) => {
  if (amount <= INVALID_AMOUNT) {
    throw new Error(INSUFFICIENT_AMOUNT_ERROR);
  }

  let transaction: Transaction;
  const amountOfLamports = new BN(amount * LAMPORTS_PER_SOL);

  if (action === "deposit") {
    const result = await marinade.addLiquidity(amountOfLamports);
    transaction = result.transaction;
  } else {
    const result = await marinade.removeLiquidity(amountOfLamports);
    transaction = result.transaction;
  }

  return { transaction };
};
